import { ColumnsSettingsViewDict } from '../typings/common';
import { FilterPartialExpression } from '../typings/filter';
import { GdStatusApprove } from '../typings/graphql-grid';
import { PricePackagesData, PricePackagesSourceParams } from '../typings/pricePackages';

export const HANDLE_PRICE_PACKAGES_COLUMNS_WIDTH_UPDATE = 'HANDLE_PRICE_PACKAGES_COLUMNS_WIDTH_UPDATE';
export type HANDLE_PRICE_PACKAGES_COLUMNS_WIDTH_UPDATE = typeof HANDLE_PRICE_PACKAGES_COLUMNS_WIDTH_UPDATE;

export interface HandlePricePackagesColumnsWidthUpdateAction {
    type: HANDLE_PRICE_PACKAGES_COLUMNS_WIDTH_UPDATE;
    width: number;
    key: string;
}

export function handlePricePackagesColumnsWidthUpdate(
    width: number,
    key: string
): HandlePricePackagesColumnsWidthUpdateAction {
    return {
        type: HANDLE_PRICE_PACKAGES_COLUMNS_WIDTH_UPDATE,
        width,
        key
    };
}

export const HANDLE_PRICE_PACKAGES_COLUMNS_VISIBILITY_CHANGE = 'HANDLE_PRICE_PACKAGES_COLUMNS_VISIBILITY_CHANGE';
export type HANDLE_PRICE_PACKAGES_COLUMNS_VISIBILITY_CHANGE = typeof HANDLE_PRICE_PACKAGES_COLUMNS_VISIBILITY_CHANGE;

export interface HandlePricePackagesColumnsVisibilityChangeAction {
    type: HANDLE_PRICE_PACKAGES_COLUMNS_VISIBILITY_CHANGE;
    columns: string[];
}

export function handlePricePackagesColumnsVisibilityChange(
    columns: string[]
): HandlePricePackagesColumnsVisibilityChangeAction {
    return {
        type: HANDLE_PRICE_PACKAGES_COLUMNS_VISIBILITY_CHANGE,
        columns
    };
}

export const HANDLE_PRICE_PACKAGES_COLUMNS_ORDER_CHANGE = 'HANDLE_PRICE_PACKAGES_COLUMNS_ORDER_CHANGE';
export type HANDLE_PRICE_PACKAGES_COLUMNS_ORDER_CHANGE = typeof HANDLE_PRICE_PACKAGES_COLUMNS_ORDER_CHANGE;

export interface HandlePricePackagesColumnsOrderChangeAction {
    type: HANDLE_PRICE_PACKAGES_COLUMNS_ORDER_CHANGE;
    columnOrder: string[];
}

export function handlePricePackagesColumnsOrderChange(
    columnOrder: string[]
): HandlePricePackagesColumnsOrderChangeAction {
    return {
        type: HANDLE_PRICE_PACKAGES_COLUMNS_ORDER_CHANGE,
        columnOrder
    };
}

export const REQUSET_PRICE_PACKAGES_ROW = 'REQUSET_PRICE_PACKAGES_ROW';
export type REQUSET_PRICE_PACKAGES_ROW = typeof REQUSET_PRICE_PACKAGES_ROW;

export interface RequestPricePackagesRow {
    type: REQUSET_PRICE_PACKAGES_ROW;
    index: number;
}

export function requestPricePackagesRow(index: number): RequestPricePackagesRow {
    return {
        type: REQUSET_PRICE_PACKAGES_ROW,
        index
    };
}

export const UPDATE_PRICE_PACKAGES_DATA = 'UPDATE_PRICE_PACKAGES_DATA';
export type UPDATE_PRICE_PACKAGES_DATA = typeof UPDATE_PRICE_PACKAGES_DATA;

export interface UpdatePricePackagesData {
    type: UPDATE_PRICE_PACKAGES_DATA;
    gridData: PricePackagesData;
}

export function updatePricePackagesData(gridData: PricePackagesData): UpdatePricePackagesData {
    return {
        type: UPDATE_PRICE_PACKAGES_DATA,
        gridData
    };
}

export const UPDATE_PRICE_PACKAGES_SOURCE_PARAMS = 'UPDATE_PRICE_PACKAGES_SOURCE_PARAMS';
export type UPDATE_PRICE_PACKAGES_SOURCE_PARAMS = typeof UPDATE_PRICE_PACKAGES_SOURCE_PARAMS;

export interface UpdatePricePackagesSourceParams {
    type: UPDATE_PRICE_PACKAGES_SOURCE_PARAMS;
    sourceParams: PricePackagesSourceParams;
}

export function updatePricePackagesSourceParams(
    sourceParams: PricePackagesSourceParams
): UpdatePricePackagesSourceParams {
    return {
        type: UPDATE_PRICE_PACKAGES_SOURCE_PARAMS,
        sourceParams
    };
}

export const RESET_PRICE_PACKAGES_DATA = 'RESET_PRICE_PACKAGES_DATA';
export type RESET_PRICE_PACKAGES_DATA = typeof RESET_PRICE_PACKAGES_DATA;

export interface ResetPricePackagesData {
    type: RESET_PRICE_PACKAGES_DATA;
}

export function resetPricePackagesData(): ResetPricePackagesData {
    return { type: RESET_PRICE_PACKAGES_DATA };
}

export const UPDATE_PRICE_PACKAGES_COLUMNS_WIDTH = 'UPDATE_PRICE_PACKAGES_COLUMNS_WIDTH';
export type UPDATE_PRICE_PACKAGES_COLUMNS_WIDTH = typeof UPDATE_PRICE_PACKAGES_COLUMNS_WIDTH;

export interface UpdatePricePackagesColumnsWidthData {
    type: UPDATE_PRICE_PACKAGES_COLUMNS_WIDTH;
    columns: ColumnsSettingsViewDict;
}

export function updatePricePackagesColumnsWidthData(
    settings: ColumnsSettingsViewDict
): UpdatePricePackagesColumnsWidthData {
    return {
        type: UPDATE_PRICE_PACKAGES_COLUMNS_WIDTH,
        columns: settings
    };
}

export const CHANGE_PRICE_PACKAGES_COLUMNS_VISIBILITY = 'CHANGE_PRICE_PACKAGES_COLUMNS_VISIBILITY';
export type CHANGE_PRICE_PACKAGES_COLUMNS_VISIBILITY = typeof CHANGE_PRICE_PACKAGES_COLUMNS_VISIBILITY;

export interface ChangePricePackagesColumnsVisibilityData {
    type: CHANGE_PRICE_PACKAGES_COLUMNS_VISIBILITY;
    columns: ColumnsSettingsViewDict;
}

export function changePricePackagesColumnsVisibilityData(
    settings: ColumnsSettingsViewDict
): ChangePricePackagesColumnsVisibilityData {
    return {
        type: CHANGE_PRICE_PACKAGES_COLUMNS_VISIBILITY,
        columns: settings
    };
}

export const CHANGE_PRICE_PACKAGES_COLUMNS_ORDER = 'CHANGE_PRICE_PACKAGES_COLUMNS_ORDER';
export type CHANGE_PRICE_PACKAGES_COLUMNS_ORDER = typeof CHANGE_PRICE_PACKAGES_COLUMNS_ORDER;

export interface ChangePricePackagesColumnsOrderData {
    type: CHANGE_PRICE_PACKAGES_COLUMNS_ORDER;
    columnOrder: Array<string>;
}

export function changePricePackagesColumnsOrderData(order: Array<string>): ChangePricePackagesColumnsOrderData {
    return {
        type: CHANGE_PRICE_PACKAGES_COLUMNS_ORDER,
        columnOrder: order
    };
}

export const UPDATE_COLUMNS_SETTINGS_PRICE_PACKAGES_STATE = 'UPDATE_COLUMNS_SETTINGS_PRICE_PACKAGES_STATE';
export type UPDATE_COLUMNS_SETTINGS_PRICE_PACKAGES_STATE = typeof UPDATE_COLUMNS_SETTINGS_PRICE_PACKAGES_STATE;

export interface UpdateColumnsSettingsPricePackagesState {
    type: UPDATE_COLUMNS_SETTINGS_PRICE_PACKAGES_STATE;
    columnsSettings: ColumnsSettingsViewDict;
}

export const updateColumnsSettingsPricePackagesState = (
    columnsSettings: ColumnsSettingsViewDict
): UpdateColumnsSettingsPricePackagesState => {
    return {
        type: UPDATE_COLUMNS_SETTINGS_PRICE_PACKAGES_STATE,
        columnsSettings
    };
};

export const PRICE_PACKAGES_NAVIGATION_GO_TO_FILTER = 'PRICE_PACKAGES_NAVIGATION_GO_TO_FILTER';
export type PRICE_PACKAGES_NAVIGATION_GO_TO_FILTER = typeof PRICE_PACKAGES_NAVIGATION_GO_TO_FILTER;

export interface PricePackagesNavigationGoToFilterAction {
    type: PRICE_PACKAGES_NAVIGATION_GO_TO_FILTER;
    expressions: FilterPartialExpression[];
}

export function pricePackagesNavigationGoToFilter(
    expressions: FilterPartialExpression[]
): PricePackagesNavigationGoToFilterAction {
    return {
        type: PRICE_PACKAGES_NAVIGATION_GO_TO_FILTER,
        expressions
    };
}

export const CHANGE_STATUS_PRICE_PACKAGE = 'CHANGE_STATUS_PRICE_PACKAGE';
export type CHANGE_STATUS_PRICE_PACKAGE = typeof CHANGE_STATUS_PRICE_PACKAGE;

export interface ChangeStatusPricePackage {
    type: CHANGE_STATUS_PRICE_PACKAGE;
    index: string;
    status: GdStatusApprove;
}

export function changeStatusPricePackage(index: string, status: GdStatusApprove): ChangeStatusPricePackage {
    return {
        type: CHANGE_STATUS_PRICE_PACKAGE,
        index,
        status
    };
}

export const SAVE_STATUS_PRICE_PACKAGE = 'SAVE_STATUS_PRICE_PACKAGE';
export type SAVE_STATUS_PRICE_PACKAGE = typeof SAVE_STATUS_PRICE_PACKAGE;

export interface SaveStatusPricePackage {
    type: SAVE_STATUS_PRICE_PACKAGE;
    index: string;
    status: GdStatusApprove;
}

export function saveStatusPricePackage(index: string, status: GdStatusApprove): SaveStatusPricePackage {
    return {
        type: SAVE_STATUS_PRICE_PACKAGE,
        index,
        status
    };
}

export const PRICE_PACKAGE_SCREEN_GO_TO_PACKAGE_EDIT = 'PRICE_PACKAGE_SCREEN_GO_TO_PACKAGE_EDIT';
export type PRICE_PACKAGE_SCREEN_GO_TO_PACKAGE_EDIT = typeof PRICE_PACKAGE_SCREEN_GO_TO_PACKAGE_EDIT;

export interface PricePackageScreenGoToPackageEditAction {
    type: PRICE_PACKAGE_SCREEN_GO_TO_PACKAGE_EDIT;
    login: string;
    id?: string;
}

export function goToPackageEdit(login: string, id?: string): PricePackageScreenGoToPackageEditAction {
    return {
        type: PRICE_PACKAGE_SCREEN_GO_TO_PACKAGE_EDIT,
        login,
        id
    };
}

export type PricePackagesAction =
    | PricePackagesNavigationGoToFilterAction
    | ChangePricePackagesColumnsVisibilityData
    | ChangePricePackagesColumnsOrderData
    | UpdatePricePackagesColumnsWidthData
    | ResetPricePackagesData
    | UpdatePricePackagesSourceParams
    | UpdatePricePackagesData
    | RequestPricePackagesRow
    | UpdateColumnsSettingsPricePackagesState
    | HandlePricePackagesColumnsOrderChangeAction
    | HandlePricePackagesColumnsVisibilityChangeAction
    | HandlePricePackagesColumnsWidthUpdateAction
    | ChangeStatusPricePackage
    | SaveStatusPricePackage
    | PricePackageScreenGoToPackageEditAction;
